export default __webpack_public_path__ + "static/media/2.c4a826b2.svg";